import { ReactNode } from "react";

import { Animation } from "./Animation";
import {
  AnimationContainer,
  InnerContainer,
  ValuesDescriptionContainer,
} from "./styles.styled";
import { TracingBeam } from "./TracingBeam";

interface ValuesSectionProps {
  children: ReactNode;
}

export const ValuesSection = ({ children }: ValuesSectionProps) => {
  return (
    <TracingBeam>
      <InnerContainer>
        <ValuesDescriptionContainer>{children}</ValuesDescriptionContainer>

        <AnimationContainer>
          <Animation />
        </AnimationContainer>
      </InnerContainer>
    </TracingBeam>
  );
};
